import script from "./AiFileUpload.vue?vue&type=script&setup=true&lang=ts"
export * from "./AiFileUpload.vue?vue&type=script&setup=true&lang=ts"

import "./AiFileUpload.scss?vue&type=style&index=0&id=14fa7b28&scoped=true&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-14fa7b28"]])

export default __exports__